import { useDocumentDatasets } from '@Hooks/Documents';
import { LoadingFrame } from '@synqo/frontend-component-library';
import { type FC, useEffect } from 'react';
import { TemplatePreview } from './TemplatePreview';
import { useOnceVisible } from './useOnceVisible';

export interface ClientRenderedPreviewProps {
    printOptionId: string;
    primaryId: string;
    onClose?: () => void;
}

export const ClientRenderedPreview: FC<ClientRenderedPreviewProps> = ({ printOptionId, primaryId, onClose }) => {
    const { ref, isVisible } = useOnceVisible<HTMLDivElement>();
    const { blobDatasets, jsonDatasets, hasErrors } = useDocumentDatasets(printOptionId, primaryId ?? '', isVisible);

    useEffect(() => {
        if (hasErrors) {
            onClose?.();
        }
    }, [hasErrors, onClose]);

    if (blobDatasets === undefined || jsonDatasets === undefined) {
        return (
            <div ref={ref}>
                <LoadingFrame />
            </div>
        );
    }

    return <TemplatePreview printOptionId={printOptionId} jsonDatasets={jsonDatasets} blobDatasets={blobDatasets} />;
};
